export const cookiePrefixesToPickUp = [
  'utm',
  'afuserid',
  'r=',
  'ttclid',
  '_ga=',
  '_ga_VYHG5X0XGR=',
  'af_c_id',
  'af_adset_id',
  'af_ad_id',
  'af_adset',
  'af_keyword_id',
  'gclid',
  'convert_experiment_data',
];

export const LILI_SUPPORT_PHONE = '(855) 545-4380';
export const LILI_SUPPORT_EMAIL = 'support@lili.co';
export const LILI_TERMS_OF_USE_URL = 'https://lili.co/legal-documents/lili-terms-of-use';
export const LILI_PRIVACY_POLICY_URL = 'https://lili.co/legal-documents/lili-privacy-policy';
export const SUNRISE_ACCOUNT_MANAGMENT_AGREEMENT_URL =
  'https://lili.co/legal-documents/sunrise-customer-agreement';
export const SUNRISE_PRIVACY_POLICY_AGREEMENT_URL =
  'https://lili.co/legal-documents/privacy-notice-sunrise';
export const SUNRISE_APPLE_AND_GOOGLE_PAY_TERMS_URL =
  'https://lili.co/legal-documents/sunrise-apple-google-pay-terms';
export const LILI_BIOMETRIC_DATA_CONSENT_URL = 'https://lili.co/legal-documents/7284-2';

export const SUBMIT_BUTTON_ID = 'formSubmitButton';

export enum PASSWORD_LESS_PARTNER_IDS_MAP {
  DNB_INTEG_1 = '8a4ea8ca-470f-4be7-a2ef-69508be415ec',
  DNB_INTEG_2 = '8b745cdb-03bf-4dad-a64d-0dd6638d0848',
  DNB_PROD = 'cc2f7c20-4c39-4272-b538-588361dee3e6',
  LILI_PARTNER = '9e584dfc-c7c2-4ce6-bc3a-e680013528be',
}

export const PARTNER_FLOW_IDS_MAP = {
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB_PROD]: 'Dnb embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB_INTEG_1]: 'Dnb embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.DNB_INTEG_2]: 'Dnb embedded',
  [PASSWORD_LESS_PARTNER_IDS_MAP.LILI_PARTNER]: 'Lili partner',
};

export const PASSWORD_LESS_PARTNER_IDS = [
  PASSWORD_LESS_PARTNER_IDS_MAP.DNB_INTEG_1,
  PASSWORD_LESS_PARTNER_IDS_MAP.DNB_INTEG_2,
  PASSWORD_LESS_PARTNER_IDS_MAP.DNB_PROD,
  PASSWORD_LESS_PARTNER_IDS_MAP.LILI_PARTNER,
];

export const USA_STATES_LIST = [
  { title: 'AL', value: 'AL' },
  { title: 'AK', value: 'AK' },
  { title: 'AZ', value: 'AZ' },
  { title: 'AR', value: 'AR' },
  { title: 'CA', value: 'CA' },
  { title: 'CO', value: 'CO' },
  { title: 'CT', value: 'CT' },
  { title: 'DE', value: 'DE' },
  { title: 'FL', value: 'FL' },
  { title: 'GA', value: 'GA' },
  { title: 'HI', value: 'HI' },
  { title: 'ID', value: 'ID' },
  { title: 'IL', value: 'IL' },
  { title: 'IN', value: 'IN' },
  { title: 'IA', value: 'IA' },
  { title: 'KS', value: 'KS' },
  { title: 'KY', value: 'KY' },
  { title: 'LA', value: 'LA' },
  { title: 'ME', value: 'ME' },
  { title: 'MD', value: 'MD' },
  { title: 'MA', value: 'MA' },
  { title: 'MI', value: 'MI' },
  { title: 'MN', value: 'MN' },
  { title: 'MS', value: 'MS' },
  { title: 'MO', value: 'MO' },
  { title: 'MT', value: 'MT' },
  { title: 'NE', value: 'NE' },
  { title: 'NV', value: 'NV' },
  { title: 'NH', value: 'NH' },
  { title: 'NJ', value: 'NJ' },
  { title: 'NM', value: 'NM' },
  { title: 'NY', value: 'NY' },
  { title: 'NC', value: 'NC' },
  { title: 'ND', value: 'ND' },
  { title: 'OH', value: 'OH' },
  { title: 'OK', value: 'OK' },
  { title: 'OR', value: 'OR' },
  { title: 'PA', value: 'PA' },
  { title: 'RI', value: 'RI' },
  { title: 'SC', value: 'SC' },
  { title: 'SD', value: 'SD' },
  { title: 'TN', value: 'TN' },
  { title: 'TX', value: 'TX' },
  { title: 'UT', value: 'UT' },
  { title: 'VT', value: 'VT' },
  { title: 'VA', value: 'VA' },
  { title: 'WA', value: 'WA' },
  { title: 'WV', value: 'WV' },
  { title: 'WI', value: 'WI' },
  { title: 'WY', value: 'WY' },
];

export const NAVIGATION_STACK_VERSION = 5;

export const  APY_RATE = '3.00';
export const EFFECTIVE_APY_DATE = 'January 1, 2025';
